'use client'

import { usePathname, useRouter } from 'next/navigation'
import { ReactNode, useState } from 'react'

import ExitSurveyAlert from '@/components/shared/exit-survey-alert'

const ClickableAppLogo = ({ appLogo }: { appLogo: ReactNode }) => {
  const pathname = usePathname()
  const router = useRouter()
  const [open, setOpen] = useState(false)

  const handleSubmit = () => {
    setOpen(false)
    router.push('/auth/partner/home')
  }

  const handleClick = () => {
    if (pathname === '/auth/partner/home/welcome-survey/take') {
      setOpen(true)
      return
    }

    return router.push('/auth/partner/home')
  }

  const onClose = () => {
    setOpen(false)
  }

  return (
    <>
      <button type='button' onClick={handleClick}>
        {appLogo}
      </button>
      <ExitSurveyAlert isOpen={open} onClose={onClose} onSubmit={handleSubmit} />
    </>
  )
}

export default ClickableAppLogo
